/* -disable no-unused-expressions */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import LoadMask from '../../../../../components/LoadMask';
import CheckboxGroup from '../../../components/CheckboxGroup';
import { PERMISSION_OPTIONS } from '../../../shared/static-options';
import { fetchBatchUpdatePlatformUsers } from '../../../../../redux/admin-platform-users';
import { getBatchUpdatePlatformUsersUI } from '../../../../../redux/selectors';

class BatchEditPermissionsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      permissionOptions: [...PERMISSION_OPTIONS],
    };
  }

  _handlePermissionChange = updatedOptions => {
    this.setState({
      permissionOptions: updatedOptions,
    });
  };

  _getSelectedPermissions = () => {
    const { permissionOptions } = this.state;
    const permissions = [];

    permissionOptions.forEach(option => {
      if (option.checked) permissions.push(option.id);

      option.subOptions &&
        option.subOptions.forEach(subOption => {
          if (subOption.checked) permissions.push(subOption.id);
        });
    });

    return permissions;
  };

  _savePermissions = () => {
    const { dispatch, userDataList } = this.props;
    const roles = this._getSelectedPermissions();
    dispatch(fetchBatchUpdatePlatformUsers(userDataList, roles));
  };

  render() {
    const { onDismiss, userDataList, batchUpdatePlatformUsersUI } = this.props;
    const { permissionOptions } = this.state;

    return (
      <Modal title="Editar permissões" size="small" onBackdropClick={onDismiss}>
        <div className="luft-edit-permissions-modal-content">
          <div className="luft-edit-permissions-modal-form-section">
            <div className="luft-edit-permissions-modal-form-section-label">
              Usuários selecionados
            </div>
            <div className="luft-edit-permissions-modal-form-selected-users">
              {userDataList &&
                userDataList.map((user, index) => (
                  // -disable-next-line react/no-array-index-key
                  <div
                    key={index}
                    className="luft-edit-permissions-modal-form-user-pill"
                  >
                    {user.name}
                  </div>
                ))}
            </div>
          </div>

          <CheckboxGroup
            label="Configurar permissões"
            options={permissionOptions}
            onChange={this._handlePermissionChange}
          />

          <div className="luft-edit-permissions-modal-footer">
            <Button skin="secondary" text="CANCELAR" onClick={onDismiss} />
            <Button
              skin="primary"
              text="SALVAR"
              onClick={this._savePermissions}
            />
          </div>
        </div>
        {batchUpdatePlatformUsersUI.isFetching && <LoadMask />}
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    batchUpdatePlatformUsersUI: getBatchUpdatePlatformUsersUI(state),
  };
}

export default connect(mapStateToProps)(BatchEditPermissionsModal);
